/** Enrollment stays in app-site; Canvas keeps its own destination and Firebase session. */
export function buildMfaEnrollmentUrl(baseUrl: string | undefined, organizationId: number | undefined): string | null {
  if (!baseUrl || !organizationId || !Number.isSafeInteger(organizationId) || organizationId <= 0) return null;
  try {
    const url = new URL(baseUrl);
    const localDevelopment = url.hostname === "localhost" || url.hostname.endsWith(".localhost");
    if (
      (url.protocol !== "https:" && !(url.protocol === "http:" && localDevelopment)) ||
      url.username ||
      url.password ||
      !["", "/"].includes(url.pathname) ||
      url.search ||
      url.hash
    )
      return null;
    url.pathname = `/orgs/${organizationId}/security`;
    return url.toString();
  } catch {
    return null;
  }
}
